































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Dialog extends Vue {
  @Prop() private value!: boolean;
  @Prop() private title!: string;
  @Prop({ default: '700px' }) private maxWidth!: string;
  @Prop({ type: Boolean, default: false }) private eager!: boolean;
}
